import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LoginService } from 'src/app/service/login.service';
import { Policies } from 'src/constants';

@Component({
    standalone: true,
    imports: [
        CommonModule,
        RouterLink,
        RouterLinkActive
    ],
    selector: 'app-side-nav-menu',
    templateUrl: './side-nav-menu.component.html',
    styleUrls: ['./side-nav-menu.component.scss']
})
export class SideNavMenuComponent implements OnInit {
    public errorCode: string;

    hidedownarrow = false;

    constructor(private loginService: LoginService) { }

    ngOnInit() { }

    get canDoAlgorithmAssistedCorrection(): boolean {
        return this.loginService.acceptedByPolicy(Policies.CanDoAlgorithmAssistedCorrection);
    }

    get canManageEmailNotifications(): boolean {
        return this.loginService.acceptedByPolicy(Policies.CanManageEmailNotifications);
    }

    get canReadStatistics(): boolean {
        return this.loginService.acceptedByPolicy(Policies.CanReadStatistics);
    }

    get canReadAllErrors(): boolean {
        return this.loginService.acceptedByPolicy(Policies.CanReadAllErrors);
    }

    get canReadErrorsInOwnUnits(): boolean {
        return this.loginService.acceptedByPolicy(Policies.CanReadErrorsInOwnUnits);
    }

    get canReadLegacyErrors(): boolean {
        return this.loginService.acceptedByPolicy(Policies.CanReadLegacyErrors);
    }
}
